import React from 'react';

import {Select} from '@kit';

import type {Ability} from '../../../../../generated/types';
import {useCharacter} from '../../character-context';
import {ABILITIES} from '../../model/abilities';
import {
	affordablePointBuyValues,
	POINT_BUY_BUDGET,
	POINT_BUY_COSTS,
	POINT_BUY_MIN,
	pointBuySpent,
} from '../../model/ability-generation';
import {abilityLabel} from '../../model/labels';
import {AbilityRow} from './ability-row';

import css from '../master.module.css';

/** приобретение за очки: 27 очков, значения от 8 до 15 по таблице цен; видны только доступные по очкам */
export const PointBuy: React.FC = () => {
	const {state, update} = useCharacter();
	const scores = state.baseAbilities;
	const left = POINT_BUY_BUDGET - pointBuySpent(scores);

	const setScore = (ability: Ability, value: number) =>
		update((current) => ({baseAbilities: {...current.baseAbilities, [ability]: value}}));

	return (
		<>
			<p className={css.pointBuyLeft}>
				Осталось очков: <b>{left}</b> / {POINT_BUY_BUDGET}
			</p>
			<div className={css.abilityInputs}>
				{ABILITIES.map((ability) => (
					<AbilityRow key={ability} ability={ability}>
						<Select
							label={abilityLabel(ability)}
							disableClear
							items={affordablePointBuyValues(scores, ability).map((value) => ({
								value,
								title: String(value),
								label: POINT_BUY_COSTS[value] ? `${value} (−${POINT_BUY_COSTS[value]})` : String(value),
							}))}
							value={scores[ability]}
							onChange={([value]) =>
								setScore(ability, value === undefined ? POINT_BUY_MIN : Number(value))
							}
						/>
					</AbilityRow>
				))}
			</div>
		</>
	);
};
